import Headroom from 'headroom.js';

function onMenuClick(e) {
	e.preventDefault();
	e.target.dispatchEvent( new CustomEvent( 'global-nav:menu', { bubbles: true } ) );
}

function onSearchClick(e) {
	e.preventDefault();
	e.target.dispatchEvent( new CustomEvent( 'global-nav:search', { bubbles: true } ) );
}

export function init() {
	const header = document.querySelector( '.wp-block-template-part--header-program' );
	const node   = document.querySelector( '.masthead-program' );

	for ( const menu of node.querySelectorAll( '.masthead-program__action--menu' ) ) {
		menu.addEventListener( 'click', onMenuClick );
	}
	for ( const search of node.querySelectorAll( '.masthead-program__action--search' ) ) {
		// search.addEventListener( 'click', onSearchClick );
	}

	// headroom sticky hide configuration - @see https://www.npmjs.com/package/headroom.js
	const headroom = new Headroom(
		header,
		{
			tolerance: {
				up: 7,
				down: 5,
			},
		}
	);

	headroom.init();
	headroom.update( headroom );
}

if ( [ 'ready', 'interactive' ].includes( document.readyState ) ) {
	init();
} else {
	document.addEventListener( 'DOMContentLoaded', init );
}
